import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { Field } from 'redux-form';
import { propOneOf } from '../../../../../../helpers/custom-prop-types';
import { validateEmail } from '../../../../../../validate/common';
import { slideSearchRegistrationValidate } from '../../../../../../validate/custom/slide_search/registration';
import PlainInputComponent from '../../../../Common/PlainInputComponent';
import SlideSearchRegistrationRequestDivisionRadio from '../../../Input/SlideSearchRegistrationRequestDivisionRadio';
/**
 * メールアドレス・ユーザー区分を表示するコンポーネント
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const SlideSearchFormEmailField = (props) => {
    const { userMode } = props;
    // ゲストでない場合、メールアドレス入力は表示させない
    if (userMode !== 'guest') {
        return null;
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'email_row' }, { children: [_jsx("div", Object.assign({ className: 'row_title' }, { children: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9" })), _jsx(Field, { className: 'form_input input-form-text', component: PlainInputComponent, name: 'email', placeholder: '', validate: validateEmail })] })), _jsx("div", Object.assign({ className: 'division_row' }, { children: _jsx(Field, { component: SlideSearchRegistrationRequestDivisionRadio, name: 'requestDivision', validate: slideSearchRegistrationValidate.requestDivision }) }))] }));
};
SlideSearchFormEmailField.propTypes = {
    userMode: propOneOf(['guest', 'client', 'free_professional', 'professional'])
        .isRequired,
};
export default SlideSearchFormEmailField;
